import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { monthNames } from '../hrms/shared/constants';
import { fullMonthNames } from '../hrms/shared/constants';
import { dayNames } from '../hrms/shared/constants';
import { format } from 'util';
@Injectable()
export class DateService {
  constructor(private datePipe:DatePipe) { }
  getTimeandDate()
  {
    var today = new Date();
    var dd = String(today.getDate());
    var mm = String(today.getMonth() + 1); //January is 0!

    var yyyy = today.getFullYear(); 
    var t =  dd + '/' + mm + '/' + yyyy;
    var date = dd + '/' + mm + '/' + yyyy;
    var hours = today.getHours();
    var minutes = today.getMinutes();
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    var h = hours < 10 ? '0'+hours : hours;
    var m = minutes < 10 ? '0'+minutes : String(minutes);
    var time = h + ':' + m + ' ' + ampm;
    var date_time = {
      date:date,
      time:time,
      month:today.getMonth() + 1,
      year: today.getFullYear(),
      day: today.getDate(),
      timeStamp:today.getTime()
    }
    return date_time;
  }
  getDate(dateInput)
  {
    var date = new Date(dateInput);
    return date.getFullYear()+'/'+(date.getMonth()+1)+'/'+date.getDate();
  }
  getTodaysDate()
  {
    var date = new Date();
    return date.getFullYear()+'/'+(date.getMonth()+1)+'/'+date.getDate();
  }

  getDatePipe(dateInput)
  {
    const month = this.datePipe.transform(date, 'MMMM');
    const dayofweek = this.datePipe.transform(date, 'DDDD');
    //console.log("dayofweek",dayofweek);
    var date = {
      fullDate: date.getDate()+", "+month+" "+date.getFullYear(),
      date: {
        day : date.getDate(),
        month: date.getMonth()+1,
        year: date.getFullYear()
      }
  }
}
getFullDate(dateInput)
{
  var date =  new Date(dateInput);
  const month = this.datePipe.transform(date, 'MMMM');
  return date.getDate()+", "+month+" "+date.getFullYear();
}

getSingleDate(dateInput)
{
  var date =  new Date(dateInput);
  return date.getDate();
}
getMonthName(dateInput)
{
  var date =  new Date(dateInput);
  return monthNames[date.getMonth()];
}

public getDayDifference(to,from)
    {
      const diffTime = Math.abs(to.getTime() - from.getTime());
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
      //console.log("diffDays",diffDays);
      return diffDays;
    }

public checkDatesFromTo(dateFrom,dateTo,dateCheck)
{
var d1 = dateFrom.split("/");
var d2 = dateTo.split("/");
var c = dateCheck.split("/");
//console.log("date ",dateFrom,dateTo,dateCheck);
var from = new Date(Number(d1[0]), parseInt(d1[1]), Number(d1[2]));  // -1 because months are from 0 to 11
var to   = new Date(Number(d2[0]), parseInt(d2[1]), Number(d2[2]));
var check = new Date(Number(c[2]), parseInt(c[1]), Number(c[0]));
var flag = check >= from && check <= to;
return flag;
}

getJoiningDate(dateInput)
{
  var date =  new Date(dateInput);
  var month = format(date.getMonth() + 1);
  var day = format(date.getDate());
  var year = format(date.getFullYear());
  return '' + (Number(day) <= 9 ? '0' + day : day) + '-' + (Number(month)<=9 ? '0' + month : month) + '-' + year;
}

getMonth(month)
{
  var date =new Date();
  return fullMonthNames[month]+", "+date.getFullYear();
}
daysInMonth(month, year) {
  return new Date(year, month, 0).getDate();
}
dayOfWeek(date) {
  return new Date(date).getDay();
}
dayNameOfWeek(date) {
  return dayNames[new Date(date).getDay()];
}

public checkDatesFromToRange(dateFrom,dateTo,dateCheck)
{
var d1 = dateFrom.split("/");
var d2 = dateTo.split("/");
var c = dateCheck.split("/");
var from = new Date(Number(d1[2]), parseInt(d1[1]), Number(d1[0]));  // -1 because months are from 0 to 11
var to   = new Date(Number(d2[2]), parseInt(d2[1]), Number(d2[0]));
var check = new Date(Number(c[2]), parseInt(c[1]), Number(c[0]));
var flag = check >= from && check <= to;
return flag;
}
}


// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/date/date.service.ts